import { useCallback } from 'react';
import { useContextParams } from '@core/params/context';
import { customEmbedEvent } from '@embed/customEmbedEvent';
import { useStore } from '../store';
import { useCustomEventPlayerActions } from './useCustomEventPlayerActions';
import { useVideoEl } from './useVideoEl';
export { EventType } from '@embed/customEmbedEvent';
/**
 *
 */
export const useCustomPlayerVideoEvent = () => {
    const videoEl = useVideoEl();
    const video = useStore((state) => state.video);
    const params = useContextParams();
    const actions = useCustomEventPlayerActions();
    return useCallback(({ type, data }) => {
        customEmbedEvent({
            type,
            params,
            data: {
                actions,
                video,
                ...(data || {}),
            },
            videoElement: videoEl,
        });
    }, [actions, params, video, videoEl]);
};
